import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/utils";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        primary: "bg-action-primary text-action-primary-foreground hover:opacity-90",
        auth: "bg-brand-blue-500 text-action-primary-foreground hover:bg-brand-blue-600 focus:ring-2 focus:ring-brand-blue-500 focus-visible:ring-brand-blue-500 disabled:bg-auth-disabled disabled:hover:bg-auth-disabled",
        secondary:
          "bg-action-secondary text-action-secondary-foreground hover:opacity-90",
        danger:
          "bg-action-danger text-action-danger-foreground hover:bg-action-danger-hover",
        ghost: "hover:bg-bg-surface",
        outline: "border border-border bg-transparent hover:bg-bg-surface",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        auth: "h-14 rounded-xl px-4 text-base font-medium",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  },
);

export interface ButtonProps
  extends
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={cn(buttonVariants({ variant, size }), className)}
        {...props}
      />
    );
  },
);
Button.displayName = "Button";
